'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.associateAttachmentsWithThreadClient = undefined;

var _noAuthApiClient = require('../../http/noAuthApiClient');

var _noAuthApiClient2 = _interopRequireDefault(_noAuthApiClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ASSOCIATE_ATTACHMENT_PATH = 'messages/v2/attachment/public/map/thread';

var associateAttachmentsWithThreadClient = exports.associateAttachmentsWithThreadClient = function associateAttachmentsWithThreadClient(_ref) {
  var fileIds = _ref.fileIds,
      sessionId = _ref.sessionId,
      threadId = _ref.threadId;

  return _noAuthApiClient2.default.post(ASSOCIATE_ATTACHMENT_PATH + '/' + threadId, {
    data: fileIds,
    query: {
      sessionId: sessionId
    }
  });
};


//////////////////
// WEBPACK FOOTER
// ./js/file-uploads/clients/associateAttachmentsWithThreadClient.js
// module id = 821
// module chunks = 2 3